import Vue from "vue";
import Router from "vue-router";
import home from "@/views/home.vue";

// 使用 Vue.use 安装插件
Vue.use(Router);

// 定义路由规则
export default new Router({
  routes: [
    {
      path: "/",
      name: "home",
      component: home,
    },
  ],
});
